/**
 * @module compressed-json
 */
'use strict';

import compress from './compress';
import decompress from './decompress';
import bind from './bind';
/** @lends module:compressed-json */


var compressedJSON = {
  bind: bind,
  compress: compress,
  decompress: decompress
};
export {compress};
export {bind};
export {decompress};

export default compressedJSON;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL2xpYi9pbmRleC5qcyJdLCJuYW1lcyI6WyJjb21wcmVzcyIsInJlcXVpcmUiLCJkZWNvbXByZXNzIiwiYmluZCIsImNvbXByZXNzZWRKU09OIiwiZXhwb3J0cyIsIm1vZHVsZSJdLCJtYXBwaW5ncyI6IkFBQUE7OztBQUdBOztBQUVBLElBQU1BLFFBQVEsR0FBR0MsT0FBTyxDQUFDLFlBQUQsQ0FBeEI7O0FBQ0EsSUFBTUMsVUFBVSxHQUFHRCxPQUFPLENBQUMsY0FBRCxDQUExQjs7QUFDQSxJQUFNRSxJQUFJLEdBQUdGLE9BQU8sQ0FBQyxRQUFELENBQXBCO0FBRUE7OztBQUNBLElBQU1HLGNBQWMsR0FBRztBQUFFRCxFQUFBQSxJQUFJLEVBQUpBLElBQUY7QUFBUUgsRUFBQUEsUUFBUSxFQUFSQSxRQUFSO0FBQWtCRSxFQUFBQSxVQUFVLEVBQVZBO0FBQWxCLENBQXZCO0FBRUFHLE9BQU8sQ0FBQ0wsUUFBUixHQUFtQkEsUUFBbkI7QUFDQUssT0FBTyxDQUFDRixJQUFSLEdBQWVBLElBQWY7QUFDQUUsT0FBTyxDQUFDSCxVQUFSLEdBQXFCQSxVQUFyQjtBQUVBSSxNQUFNLENBQUNELE9BQVAsR0FBaUJELGNBQWpCIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBAbW9kdWxlIGNvbXByZXNzZWQtanNvblxuICovXG4ndXNlIHN0cmljdCdcblxuY29uc3QgY29tcHJlc3MgPSByZXF1aXJlKCcuL2NvbXByZXNzJylcbmNvbnN0IGRlY29tcHJlc3MgPSByZXF1aXJlKCcuL2RlY29tcHJlc3MnKVxuY29uc3QgYmluZCA9IHJlcXVpcmUoJy4vYmluZCcpXG5cbi8qKiBAbGVuZHMgbW9kdWxlOmNvbXByZXNzZWQtanNvbiAqL1xuY29uc3QgY29tcHJlc3NlZEpTT04gPSB7IGJpbmQsIGNvbXByZXNzLCBkZWNvbXByZXNzIH1cblxuZXhwb3J0cy5jb21wcmVzcyA9IGNvbXByZXNzXG5leHBvcnRzLmJpbmQgPSBiaW5kXG5leHBvcnRzLmRlY29tcHJlc3MgPSBkZWNvbXByZXNzXG5cbm1vZHVsZS5leHBvcnRzID0gY29tcHJlc3NlZEpTT05cbiJdfQ==